import { render, staticRenderFns } from "./SysPositionList.vue?vue&type=template&id=4a9b4d24&scoped=true"
import script from "./SysPositionList.vue?vue&type=script&lang=js"
export * from "./SysPositionList.vue?vue&type=script&lang=js"
import style0 from "./SysPositionList.vue?vue&type=style&index=0&id=4a9b4d24&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9b4d24",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a9b4d24')) {
      api.createRecord('4a9b4d24', component.options)
    } else {
      api.reload('4a9b4d24', component.options)
    }
    module.hot.accept("./SysPositionList.vue?vue&type=template&id=4a9b4d24&scoped=true", function () {
      api.rerender('4a9b4d24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/SysPositionList.vue"
export default component.exports